module.exports = __webpack_public_path__ + "html/bd-title.template.html";